// ISO 3166-1 alpha-2 codes for countries referenced in the dataset.
// Regions, seas and cities fall back to the first letters of their name.
const COUNTRY_CODES: Record<string, string> = {
  Italia: "IT",
  Cina: "CN",
  Russia: "RU",
  Libia: "LY",
  Siria: "SY",
  Iran: "IR",
  Germania: "DE",
  Grecia: "GR",
  Turchia: "TR",
  Algeria: "DZ",
  Tunisia: "TN",
  Cipro: "CY",
  Slovenia: "SI",
  Serbia: "RS",
  USA: "US",
  "Stati Uniti": "US",
  "Stati Uniti d'America": "US",
  UE: "EU",
  Europa: "EU",
  Lussemburgo: "LU",
  "Emirati Arabi Uniti": "AE",
  Azerbaigian: "AZ",
  Francia: "FR",
  India: "IN",
  "Costa d'Avorio": "CI",
  Vietnam: "VN",
  Kenya: "KE",
  Egitto: "EG",
  Qatar: "QA",
  Giappone: "JP",
  Spagna: "ES",
  Portogallo: "PT",
  Bielorussia: "BY",
  Kazakhstan: "KZ",
  Ucraina: "UA",
  Malta: "MT",
  Panama: "PA",
  Singapore: "SG",
  "Hong Kong": "HK",
  "Arabia Saudita": "SA",
  Marocco: "MA",
  Afghanistan: "AF",
  Pakistan: "PK",
  Romania: "RO",
  Bulgaria: "BG",
  Croazia: "HR",
  Albania: "AL",
  "Bosnia ed Erzegovina": "BA",
  "Bosnia-Erzegovina": "BA",
  Bosnia: "BA",
  Montenegro: "ME",
  "Macedonia del Nord": "MK",
  Macedonia: "MK",
  Kosovo: "XK",
  Slovacchia: "SK",
  Ungheria: "HU",
  "Repubblica Ceca": "CZ",
  Cechia: "CZ",
  Austria: "AT",
  Svizzera: "CH",
  "Paesi Bassi": "NL",
  Olanda: "NL",
  Belgio: "BE",
  "Regno Unito": "GB",
  Irlanda: "IE",
  Polonia: "PL",
  Svezia: "SE",
  Finlandia: "FI",
  Norvegia: "NO",
  Danimarca: "DK",
  Estonia: "EE",
  Lettonia: "LV",
  Lituania: "LT",
  Sudafrica: "ZA",
  Nigeria: "NG",
  Brasile: "BR",
  Argentina: "AR",
  Messico: "MX",
  Canada: "CA",
  Australia: "AU",
};

const STOP_WORDS = new Set([
  "di",
  "del",
  "dello",
  "della",
  "dei",
  "degli",
  "delle",
  "e",
  "ed",
  "il",
  "lo",
  "la",
  "i",
  "gli",
  "le",
  "un",
  "una",
]);

export function countryMark(name: string): string {
  const code = COUNTRY_CODES[name];
  if (code) return code;
  const content = name
    .split(/\s+/)
    .filter((w) => w && !STOP_WORDS.has(w.toLowerCase()));
  if (content.length >= 2) {
    return (
      content[0]!.charAt(0) + content[content.length - 1]!.charAt(0)
    ).toUpperCase();
  }
  return name.slice(0, 3).toUpperCase();
}

/**
 * ISO 3166-1 alpha-2 code for a known place name (Italian).
 * Returns null for cities/regions/seas that are not stand-alone countries
 * (these still get a marker on the map via PLACE_COORDS, but they don't
 * trigger a country fill). `UE` / `Europa` map to a virtual `EU` so the
 * caller can decide whether to highlight every EU country or skip.
 */
export function isoForPlace(name: string): string | null {
  const code = COUNTRY_CODES[name];
  if (!code) return null;
  // ISO 3166-1 has no entry for EU; we use it as a sentinel for the caller.
  return code;
}
